import { Box, Spinner, Text } from "@adfenix/alexandria";
import { TemplateService } from "@adfenix/types";
import { fillTemplate } from "api/services";
import { useQuery } from "@tanstack/react-query";
import { isFillFacebookContentTemplateResponse } from "utils/types";
import { toast } from "react-toastify";

interface Props {
  subjectId: string | undefined;
  templateId: string;
  channel: TemplateService.ChannelType;
  subjectType: TemplateService.SubjectType;
}

export const TemplatePreview = ({
  subjectId,
  templateId,
  channel,
  subjectType
}: Props) => {
  const {
    data: templateResponse,
    isError: fillTemplateError,
    isFetching: isLoadingTemplate
  } = useQuery(
    ["fillTemplates", templateId],
    () =>
      fillTemplate(channel, {
        subjectId: subjectId!,
        subjectType,
        templateId,
        applyFormattingRules: false
      }),
    {
      enabled: Boolean(subjectId),
      retry: false
    }
  );

  if (fillTemplateError) {
    toast.error("Failed to preview template");
    return null;
  }

  if (isLoadingTemplate) {
    return <Spinner />;
  }

  if (!templateResponse) {
    return null;
  }

  return (
    <Box pY="s">
      {isFillFacebookContentTemplateResponse(templateResponse) && (
        <>
          <Text as="p" bold>
            Ad headline
          </Text>
          <Text as="p">{templateResponse.headline}</Text>

          <Text as="p" bold>
            Ad description
          </Text>
          <Text as="p">{templateResponse.description}</Text>
        </>
      )}

      <Text as="p" bold>
        Ad message
      </Text>
      <Text as="p">{templateResponse.message}</Text>
    </Box>
  );
};
